var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cf-node-properties__hours-filter-breaks" }, [
    _c("strong", [_vm._v("Breaks")]),
    _vm._v(" "),
    _c(
      "ul",
      _vm._l(_vm.breaks, function(b, index) {
        return _c("li", { key: index }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.breakStartTime(b.startTime.hour, b.startTime.minute)) +
              " for " +
              _vm._s(b.lengthInMin) +
              " minutes\n      "
          ),
          _c(
            "button",
            {
              staticClass: "cf-node__action m-l-5",
              on: {
                click: function($event) {
                  return _vm.removeBreak(index)
                }
              }
            },
            [
              _c("i", {
                staticClass: "fa fa-trash",
                attrs: { "aria-hidden": "true" }
              })
            ]
          )
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }